import React from 'react'
import { Document, Page, StyleSheet, View, Text, Image } from "@react-pdf/renderer";
import getLogo from './getLogo'

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    justifyContent: 'space-between',
    backgroundColor: 'white',
    fontSize: '10pt',
    padding: '2cm',
    textAlign: 'justify'
  },
  logo: {
    width: 50,
    height: 50,
  },
  title:{
    fontSize: '14pt',
  },
  main:{
    border: '1px solid black',
    borderRadius: 8,
    backgroundColor: '#eeeeee',
    padding: 12,
  },
  obs: {
    color: 'gray',
    fontSize: '9pt',
    lineHeight: '1.5pt',
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    maxWidth: '100%',
    marginBottom: 4,
  },
  content:{
    lineHeight: '2pt',
  },
  field: {
    fontSize: '11pt',
    color: 'darkblue',
  },
  center:{
    textAlign: 'center',
  }
});

const emapoPdf = ({ nome, cpf, procedimentos, cidade, estado, data,
                   nomeExibicao, crm, risk, groupName, logoName}) => (

<Document title="APA" author={nome} creator="www.avaliacaopreanestesica.com">
  <Page style={styles.page} wrap={false}>
    <View style={styles.row}>
        <View><Image style={styles.logo} src={getLogo(logoName)}/></View>
        <View style={styles.center}>
          <Text style={styles.title}>ESCORE DE EMAPO PARA RISCO CARDÍACO OPERATÓRIO</Text>
        </View>
    </View>
    <View>
      <Text style={styles.content}> NOME: <Text style={styles.field}> {nome} </Text></Text>
      <Text style={styles.content}>PROCEDIMENTO(S): {"\n"}<Text style={styles.field}> {procedimentos} </Text></Text>
    </View>
    <View>
        {risk === 0 &&
          <Text style={styles.main}>
            <Text style={styles.content}>- Não foi identificada nenhuma variável de Emapo{"\n"}</Text>
            <Text style={styles.content}>- Nesse caso, a classificação do risco para óbito* e/ou eventos cardíacos** é <Text style={styles.field}> MUITO BAIXO</Text> com a incidência <Text style={styles.field}> menor que 1%</Text>{"\n"}</Text>
            <Text style={styles.content}>* óbito ocorrido no período antecedente à alta hospitalar pós-operatória{"\n"}</Text>
            <Text style={styles.content}>** eventos cardíacos incluem: eventos isquêmicos (angina instável e infarto do miocárdio), eventos embólicos e arritmias cardíacas{"\n"}</Text>
          </Text>
        }
        {risk > 0 && risk < 6 &&
          <Text style={styles.main}>
            <Text style={styles.content}>- O paciente somou <Text style={styles.field}> {risk} </Text> pontos no escore Emapo{"\n"}</Text>
            <Text style={styles.content}>- Nesse caso, a classificação do risco para óbito* e/ou eventos cardíacos** é <Text style={styles.field}> BAIXO</Text> com a incidência <Text style={styles.field}> entre 1 e 3%</Text>{"\n"}</Text>
            <Text style={styles.content}>* óbito ocorrido no período antecedente à alta hospitalar pós-operatória{"\n"}</Text>
            <Text style={styles.content}>** eventos cardíacos incluem: eventos isquêmicos (angina instável e infarto do miocárdio), eventos embólicos e arritmias cardíacas{"\n"}</Text>
          </Text>
        }
        {risk > 5 && risk < 11 &&
          <Text style={styles.main}>
          <Text style={styles.content}>- O paciente somou <Text style={styles.field}> {risk} </Text> pontos no escore Emapo{"\n"}</Text>
          <Text style={styles.content}>- Nesse caso, a classificação do risco para óbito* e/ou eventos cardíacos** é <Text style={styles.field}> MODERADO</Text> com a incidência <Text style={styles.field}> entre 3 e 7%</Text>{"\n"}</Text>
          <Text style={styles.content}>* óbito ocorrido no período antecedente à alta hospitalar pós-operatória{"\n"}</Text>
          <Text style={styles.content}>** eventos cardíacos incluem: eventos isquêmicos (angina instável e infarto do miocárdio), eventos embólicos e arritmias cardíacas{"\n"}</Text>
          </Text>
        }
        {risk > 10 && risk < 16 &&
          <Text style={styles.main}>
          <Text style={styles.content}>- O paciente somou <Text style={styles.field}> {risk} </Text> pontos no escore Emapo{"\n"}</Text>
          <Text style={styles.content}>- Nesse caso, a classificação do risco para óbito* e/ou eventos cardíacos** é <Text style={styles.field}> ELEVADO</Text> com a incidência <Text style={styles.field}> entre 7 e 13%</Text>{"\n"}</Text>
          <Text style={styles.content}>* óbito ocorrido no período antecedente à alta hospitalar pós-operatória{"\n"}</Text>
          <Text style={styles.content}>** eventos cardíacos incluem: eventos isquêmicos (angina instável e infarto do miocárdio), eventos embólicos e arritmias cardíacas{"\n"}</Text>
          </Text>
        }
        {risk > 15 &&
          <Text style={styles.main}>
          <Text style={styles.content}>- O paciente somou <Text style={styles.field}> {risk} </Text> pontos no escore Emapo{"\n"}</Text>
          <Text style={styles.content}>- Nesse caso, a classificação do risco para óbito* e/ou eventos cardíacos** é <Text style={styles.field}> MUITO ELEVADO</Text> com a incidência <Text style={styles.field}> maior que 13%</Text>{"\n"}</Text>
          <Text style={styles.content}>* óbito ocorrido no período antecedente à alta hospitalar pós-operatória{"\n"}</Text>
          <Text style={styles.content}>** eventos cardíacos incluem: eventos isquêmicos (angina instável e infarto do miocárdio), eventos embólicos e arritmias cardíacas{"\n"}</Text>
          </Text>
        }
    </View>
    <View>
      <Text style={styles.content}>
      Sobre o Escore de Emapo:{"\n"}
      - O EMAPO é um método que foi desenvolvido em 2007, no Brasil, pela Sociedade
      de Cardiologia do Estado de São Paulo. Ele propõe uma nova classificação bem
      completa, que contempla 27 diferentes variáveis. Cada uma destas variáveis possui
      uma pontuação específica, que devem ser somadas de modo que o valor encontrado
      estratificará o risco perioperatório do paciente em 5 níveis (muito baixo, baixo,
      moderado, elevado e muito elevado), de acordo com as taxas de complicações esperadas
      (menor que 1%, 1-3%, 3-7%, 7-13% e maior que 13%, respectivamente).{"\n"}
      </Text>
    </View>
    <View>
      <Text style={styles.obs}>
      Todas as informações aqui contidas têm caráter apenas informativo.{"\n"}
      Quaisquer condutas médicas devem ser decididas pelo médico assistente
      juntamente com o paciente, respeitando os quatro princípios bioéticos
      fundamentais, quais sejam: autonomia, beneficência, não-maleficência e justiça.
      </Text>
      <Text style={styles.obs}>
      {"\n"}Fontes:{"\n"}
      - Pinho C et al. Multicenter study of perioperative evaluation for noncardiac surgeries in Brazil. 2007
      - Loureiro B. Perioperative risk scores for non-cardiac surgery: descriptions and comparisons. 2014
      - Gualandro DM et al. 3a Diretriz de Avaliação Cardiovascular Perioperatória da Sociedade Brasileira de Cardiologia. 2017
      </Text>
    </View>
    <View style={styles.center}>
      <Text>
        ______________________________________________________________
      </Text>
      <Text>
        ASSINATURA DO MÉDICO ANESTESIOLOGISTA
      </Text>
      <Text>
        {groupName ? groupName : (nomeExibicao ? nomeExibicao : 'www.avaliacaopreanestesica.com')}
        {!groupName && crm && ` CRM: ${crm}`}
      </Text>
    </View>
    <View style={styles.center}>
      <Text style={styles.data}>
        {cidade && `${cidade}/${estado},`} {data.toLocaleDateString()}
      </Text>
    </View>
  </Page>
</Document>
);

export default emapoPdf
